// removed by extract-text-webpack-plugin
module.exports = {"contact-info-block":"_3qaO_0PX7m2xsXCPsU_ZWI","a-link":"_2g-ElqKytmQyb4280ETaJ1","a-link--navigation":"_2B-qSgbIZ_tKJ1ARj4sXKL"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/CheckoutContact/style.scss
// module id = 931
// module chunks = 0